import { sanitizeTelemetry } from '@borradh-workspace/observability/telemetry-sanitizer';
import type { CaptureResult } from 'posthog-js';

/** Scrub event copies. Replay has its own collection policy. */
export function sanitizeBrowserTelemetry(
  event: CaptureResult | null,
  projectToken?: string
): CaptureResult | null {
  if (!event || event.event === '$snapshot') return event;
  const safe = sanitizeTelemetry(event);
  // posthog-js adds its public project key before before_send. Restore only
  // the configured routing key, not arbitrary or nested token properties.
  if (projectToken && event.properties.token === projectToken)
    safe.properties.token = projectToken;
  return safe;
}
